<template>
  <section class="head--section-detail">
    <div v-if="dataUser.role === 'admin'">
      <head-detail-banner-admin :colorArray="colorArray" :isModal="isModal" :ticket="ticket" :masterData="masterData"
        @updateTicket="updateTicket"></head-detail-banner-admin>
      <head-detail-answer v-if="!!ticket && !!ticket.last_message && !!ticket.last_message.resolution_date"
        :resolution_date="ticket.last_message.resolution_date"></head-detail-answer>
      <head-detail-resume-admin :ticket="ticket" :isModal="isModal" :masterData="masterData"></head-detail-resume-admin>
    </div>
    <div v-else>
      <head-detail-banner-seller :colorArray="colorArray" :isModal="isModal" :ticket="ticket" :masterData="masterData"
        @updateTicket="updateTicket"></head-detail-banner-seller>
      <head-detail-answer v-if="!!ticket && !!ticket.last_message && !!ticket.last_message.resolution_date"
        :resolution_date="ticket.last_message.resolution_date"></head-detail-answer>
     <head-detail-resume-seller :ticket="ticket" :isModal="isModal" :masterData="masterData"></head-detail-resume-seller>
    </div>
  </section>
</template>
<script>
import HeadDetailAnswer from '@/views/modules/tickets/components/Detail/Head/HeadDetailAnswer.vue'
import HeadDetailResumeAdmin from '@/views/modules/tickets/components/Detail/Head/HeadDetailResumeAdmin.vue'
import HeadDetailBannerAdmin from '@/views/modules/tickets/components/Detail/Head/headDetailBannerAdmin.vue'
import HeadDetailBannerSeller from '@/views/modules/tickets/components/Detail/Head/HeadDetailBannerSeller.vue'
import HeadDetailResumeSeller from '@/views/modules/tickets/components/Detail/Head/HeadDetailResumeSeller.vue'
export default {
  props: ['ticket', 'masterData', 'colorArray', 'isModal'],
  components: { HeadDetailAnswer, HeadDetailResumeAdmin, HeadDetailBannerAdmin, HeadDetailBannerSeller, HeadDetailResumeSeller },
  data() {
    return {
    }
  },
  computed: {
    dataUser() {
      return this.$session.get('cas_user')
    }
  },
  methods: {
    updateTicket() {
      this.$emit('updateTicket', true)
    }
  }
}
</script>
<style lang="scss">
.head--section-detail {
  .head--ticket--detail {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .font--primary {
    font-size: 14px;
  }

  .font--secondary {
    font-size: 12px;
  }
}
</style>